var _line, _line2, _line3, _path, _circle, _path2, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizGame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 80,
    x2: 200,
    y2: 320,
    stroke: "white",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 160,
    x2: 280,
    y2: 160,
    stroke: "white",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 240,
    x2: 280,
    y2: 240,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 140C160 130 165 125 175 125C185 125 190 130 190 140C190 152 175 150 175 160",
    stroke: "#3B82F6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 170,
    r: 4,
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210 220C210 210 215 205 225 205C235 205 240 210 240 220C240 232 225 230 225 240",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 250,
    r: 4,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 80,
    r: 12,
    fill: "#EF4444"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 320,
    r: 12,
    fill: "#3B82F6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizGame);
export default __webpack_public_path__ + "static/media/quiz-game.0db4b213ebd56199ec8b7ce744f86ca2.svg";
export { ForwardRef as ReactComponent };